import {IAlterationsState} from '../states'
import { AlterationsActionTypes, AlterationsTypeKeys } from '../types'

export const initialAlterationsState: IAlterationsState = {
  isAlterationsModalOpen: false
}

const alterations = (
  state: IAlterationsState = initialAlterationsState,
  action: AlterationsActionTypes
): IAlterationsState => {
  switch (action.type) {
    case AlterationsTypeKeys.SET_ALTERATIONS_MODAL_OPEN:
      return { ...state, isAlterationsModalOpen: action.payload }
    default:
      return state
  }
}

export default alterations
